import { render, staticRenderFns } from "./RenderTotalGradeOnlinePeople.vue?vue&type=template&id=2f31bace"
import script from "./RenderTotalGradeOnlinePeople.vue?vue&type=script&lang=js"
export * from "./RenderTotalGradeOnlinePeople.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports